<template>
  <div class="forbrug-filters">
    <div class="forbrug-filters__item">
      <label class="label is-small" for="forbrug-period">Måned</label>
      <div class="select">
        <select
          id="forbrug-period"
          :value="period"
          @change="$emit('update:period', $event.target.value); $emit('change')"
        >
          <option v-for="option in periodOptions" :key="option.value" :value="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>
    </div>
    <div class="forbrug-filters__item">
      <label class="label is-small" for="forbrug-vehicle">Bil</label>
      <div class="select">
        <select
          id="forbrug-vehicle"
          :value="vehicle"
          @change="$emit('update:vehicle', $event.target.value); $emit('change')"
        >
          <option value="">Alle</option>
          <option v-for="item in vehicles" :key="item.id" :value="String(item.id)">
            {{ item.name }}
          </option>
        </select>
      </div>
    </div>
    <div v-if="isAdmin" class="forbrug-filters__item">
      <label class="label is-small" for="forbrug-account">Husstand</label>
      <div class="select">
        <select
          id="forbrug-account"
          :value="account"
          @change="$emit('update:account', $event.target.value); $emit('change')"
        >
          <option value="">Alle</option>
          <option v-for="item in accounts" :key="item.guid" :value="item.guid">
            {{ item.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="forbrug-filters__item">
      <span class="label is-small forbrug-filters__label-spacer" aria-hidden="true">&nbsp;</span>
      <button
        type="button"
        class="button"
        :disabled="!dirty"
        @click="$emit('reset')"
      >Nulstil filtre</button>
    </div>
    <div v-if="isAdmin" class="forbrug-filters__item forbrug-filters__item--end">
      <span class="label is-small forbrug-filters__label-spacer" aria-hidden="true">&nbsp;</span>
      <button
        type="button"
        class="button"
        @click="$emit('open-share-links')"
      >Regnings-mails</button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ForbrugFilters',
  props: {
    period: { type: String, required: true },
    vehicle: { type: String, default: '' },
    account: { type: String, default: '' },
    periodOptions: { type: Array, default: () => [] },
    vehicles: { type: Array, default: () => [] },
    accounts: { type: Array, default: () => [] },
    isAdmin: { type: Boolean, default: false },
    dirty: { type: Boolean, default: false }
  },
  emits: ['update:period', 'update:vehicle', 'update:account', 'change', 'reset', 'open-share-links']
})
</script>

<style scoped>
.forbrug-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1rem;
  margin-bottom: 1.25rem;
}

.forbrug-filters__item {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.forbrug-filters__item--end {
  margin-left: auto;
}

.forbrug-filters .label {
  margin-bottom: 0.25rem;
  line-height: 1.25;
}

.forbrug-filters__label-spacer {
  visibility: hidden;
  user-select: none;
}

.forbrug-filters .select,
.forbrug-filters .button {
  height: 2.5em;
}

.forbrug-filters .select select {
  height: 2.5em;
}
</style>
